import { render, staticRenderFns } from "./gc-popup-customer-statement.vue?vue&type=template&id=aa293e60"
import script from "./gc-popup-customer-statement.vue?vue&type=script&lang=js"
export * from "./gc-popup-customer-statement.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-customer-statement.vue?vue&type=style&index=0&id=aa293e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports